// New component created by srini on 02-04-25 for engagement  section

import { Grid, Typography, Modal, IconButton } from "@mui/material"
import CloseIcon from '@mui/icons-material/Close';

import { withStyles } from "@material-ui/core/styles"

import styles from './engagementStyles'

const IncomeForm = ({ classes, showModal, setShowModal, agentIncome }) => {

    const hasData = Object.keys(agentIncome).length > 0

    return (
        <Modal
            open={showModal}
            onClose={() => setShowModal(false)}
            aria-labelledby="modal-title"
            aria-describedby="modal-description"
        >
            <Grid className={classes.modalStyle} >

                <Typography id="modal-title" className={classes.subTxt}>Subscription Details</Typography>
                <IconButton onClick={() => setShowModal(false)} sx={{ position: "absolute", top: 10, right: 10 }}>
                    <CloseIcon fontSize="14px" />
                </IconButton>
                {hasData ? (
                    Object.entries(agentIncome).map(([subscription, data]) => (
                        <Grid key={subscription} style={{ display: 'flex', justifyContent: 'start', alignItems: 'start', marginLeft: '80px' }}>
                            <Typography className={classes.subTtlTxt} style={{ fontWeight: '500' }}>{subscription.charAt(0).toUpperCase() + subscription.slice(1)}</Typography>
                            <Typography className={classes.subTtlTxt}> : {data.totalAmount.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</Typography>
                        </Grid>
                    ))
                ) : (
                    <Typography className={classes.subTtlTxt}>
                        No records found
                    </Typography>
                )}
            </Grid>
        </Modal>
    )
}

export default withStyles(styles)(IncomeForm)